module.exports = __webpack_public_path__ + "img/image6.6f1a9420.png";